import { Link } from 'react-router-dom';
import { Gauge, Lightning, ShieldCheck } from '@phosphor-icons/react';
import { portalRoutes } from '../../lib/portalRoutes';
import { getPortalDesignBootstrap } from '../../lib/portalDesignBootstrap';

export const PublicLayout = ({ eyebrow, title, description, children, footer }) => {
  const portalDesign = getPortalDesignBootstrap();
  const backgroundImage = '/assets/portals/chiptuningfile/login-engine.png';

  return (
    <div className="relative min-h-screen overflow-hidden bg-background text-foreground">
      <div
        className="absolute inset-0 bg-cover bg-[center_center] bg-no-repeat"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(6,7,10,0.8)_0%,rgba(6,7,10,0.54)_38%,rgba(6,7,10,0.78)_100%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_22%_46%,rgba(255,34,34,0.28),transparent_24%),radial-gradient(circle_at_top_left,rgba(255,42,42,0.2),transparent_28%),radial-gradient(circle_at_bottom_right,rgba(255,255,255,0.05),transparent_24%)]" />
      <div className="pointer-events-none absolute inset-0">
        <div
          className="absolute inset-y-0 left-0 w-[42rem]"
          style={{ background: `linear-gradient(90deg, rgba(4,5,8,0.76) 0%, rgba(4,5,8,0.42) 55%, transparent 100%), radial-gradient(circle at top left, ${portalDesign.primaryColor}2a, transparent 58%)` }}
        />
      </div>

      <div className="relative z-10 flex min-h-screen w-full flex-col px-6 py-8 lg:px-12 xl:px-16">
        <header className="flex items-center justify-between border-b border-border/80 pb-6">
          <Link to={portalRoutes.login} className="font-heading text-2xl font-extrabold tracking-tight">
            {portalDesign.logoUrl ? (
              <img src={portalDesign.logoUrl} alt={portalDesign.portalName} className="h-10 max-w-[200px] object-contain" />
            ) : (
              portalDesign.portalName
            )}
          </Link>

          <div className="hidden items-center gap-5 text-sm text-muted-foreground md:flex">
            <span className="flex items-center gap-2">
              <Gauge className="h-4 w-4 text-primary" weight="fill" />
              B2B File-Service
            </span>
            <span className="flex items-center gap-2">
              <Lightning className="h-4 w-4 text-primary" weight="fill" />
              30-60 Min. Bearbeitung
            </span>
            <span className="flex items-center gap-2">
              <ShieldCheck className="h-4 w-4 text-primary" weight="fill" />
              Händlerbereich
            </span>
          </div>
        </header>

        <div className="grid flex-1 gap-12 py-10 lg:grid-cols-[minmax(0,1.25fr)_minmax(28rem,34rem)] lg:items-center">
          <section className="space-y-6 lg:max-w-3xl lg:pr-12 xl:pr-20">
            <div className="inline-flex items-center rounded-sm border border-primary/30 bg-black/30 px-3 py-1 text-xs font-semibold uppercase tracking-[0.24em] text-primary backdrop-blur-sm">
              {eyebrow}
            </div>
            <div className="max-w-3xl space-y-4 rounded-sm border border-white/10 bg-black/16 p-6 shadow-[0_24px_80px_rgba(0,0,0,0.35)] backdrop-blur-[2px] md:p-8">
              <h1 className="max-w-2xl font-heading text-4xl font-black tracking-tight md:text-5xl">
                {title}
              </h1>
              <p className="max-w-xl text-base leading-7 text-slate-300 md:text-lg">
                {description}
              </p>
            </div>
          </section>

          <section className="w-full max-w-[34rem] justify-self-end rounded-sm border border-white/10 bg-[rgba(14,16,22,0.84)] p-6 shadow-[0_0_0_1px_rgba(255,255,255,0.03),0_28px_80px_rgba(0,0,0,0.48)] backdrop-blur-md md:p-8">
            {children}
          </section>
        </div>

        <footer className="border-t border-border/80 pt-6 text-sm text-muted-foreground">
          {footer}
        </footer>
      </div>
    </div>
  );
};
